import {
  ForwardedRef,
  Ref,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import ReactPlayer from "react-player";
import { OnProgressProps } from "react-player/base";
import useHomeworkState from "../state/homework.state";
import AudioManager, { AudioManagerHandle } from "./AudioManager";

export type AudioDescriptionManagerHandle = {
  onPlay: () => void;
  onPause: () => void;
  onSeek: () => void;
  onProgress: (videoProgress: OnProgressProps) => Promise<void>;
};

type Props = {
  videoRef: ReactPlayer;
  isDisabled?: boolean;
};

const AudioDescriptionManager = (
  { videoRef, isDisabled = false }: Props,
  ref: ForwardedRef<AudioDescriptionManagerHandle>,
) => {
  const audioManagerRef = useRef<AudioManagerHandle>(null);
  const { audioDescriptions, setAudioDescriptions } = useHomeworkState();

  useImperativeHandle(
    ref,
    () => ({
      onPlay: () => audioManagerRef.current?.onPlay(),
      onPause: () => audioManagerRef.current?.onPause(),
      onSeek: () => audioManagerRef.current?.onSeek(),
      onProgress: async (progress) =>
        audioManagerRef.current?.onProgress(progress, 0),
    }),
    [],
  );

  return (
    <AudioManager
      audios={audioDescriptions}
      setAudios={setAudioDescriptions}
      videoRef={videoRef}
      ref={audioManagerRef}
      isDisabled={isDisabled}
    />
  );
};

export default forwardRef(AudioDescriptionManager) as (
  props: Props & { ref?: Ref<AudioDescriptionManagerHandle> },
) => JSX.Element;
